import {GenMetricDetails} from '../../generated/serverModels/GenMetricDetails';

export class MetricDetails extends GenMetricDetails {
  constructor(details?: MetricDetails) {
    super(details);
  }




  public getAggregationValue(aggregation: 'min'|'max'|'avg'|'sum'): number {
    switch (aggregation) {
      case 'min':
        return this.min;
      case 'max':
        return this.max;
      case 'avg':
        return this.avg;
      case 'sum':
        return this.sum;
    }
  }
}
